import { useEffect, useState } from 'react';
import axios from 'axios';
import { EmployeeGoal } from '../models/GoalsInterfaces';

export const useGetUserGoals = (selectedPeriodId: string) => {
  const [goals, setGoals] = useState<EmployeeGoal[]>([]);
  const [loadingGoals, setLoadingGoals] = useState(false);

  const getAllUserGoals = async () => {
    setLoadingGoals(true);
    try {
      const response = await axios.get(
        `api/goals?periodId=${selectedPeriodId}`
      );
      setGoals(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingGoals(false);
    }
  };

  useEffect(() => {
    if (selectedPeriodId) {
      getAllUserGoals();
    }
  }, [selectedPeriodId]);

  return { goals, loadingGoals, getAllUserGoals };
};
